import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams  } from 'react-router-dom';
import apiService from '../../../Auth/apiService';
import { useForm, Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import SweetAlert2 from 'react-sweetalert2';
import MenuCaracterizacion from '../Componentes/MenuCaracterizacion';
import SeccionPageHeader from '../../Utils/SeccionPageHeader';
import CargandoSpinner from '../../Utils/CargandoSpinner';
import { useAuth } from '../../../Auth/AuthContext';
import { FaCalendar } from 'react-icons/fa';

// CustomInput moved outside of Persona for best practices and prop validation
const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        ref={ref}
        aria-label="Seleccionar fecha"
        style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
    >
        <input value={value} readOnly className='widthCalendar' tabIndex={-1} style={{ pointerEvents: 'none', background: 'transparent', border: 'none' }} />
        <FaCalendar />
    </button>
));

export default function Persona() {
    const { token, user, rol, programa } = useAuth();
    const hasRun = useRef(false);
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const { id } = useParams();
    const { idPersona } = useParams();
    const { idCabezaFamilia } = useParams();
    const [tipoIdentificaciones, setTipoIdentificaciones] = useState([]);
    const [estadosvictima, setEstadosvictima] = useState([]);
    const [estadosvictimaFiltrados, setEstadosvictimaFiltrados] = useState([]);
    const [sexo, setSexo] = useState([]);
    const [minoria, setMinoria] = useState([]);
    const [tiposOrientacionSexual, setTiposOrientacionSexual] = useState([]);
	const [tiposIdentidadGenero, setTiposIdentidadGenero] = useState([]);
	const [tiposHabitanteCalle, setTiposHabitanteCalle] = useState([]);
	const [tiposEstrato, setTiposEstrato] = useState([]);
    const [paises, setPaises] = useState([]);
    const [pendingPaisOrigen, setPendingPaisOrigen] = useState(null);
    const [discapacidades, setDiscapacidades] = useState([]);
    const [causasdiscapacidad, setCausasdiscapacidad] = useState([]);
    const [oficios, setOficios] = useState([]);
    const [actividades, setActividades] = useState([]);
    const [tipoestudios, setTipoestudios] = useState([]);
    const [razonnoestudio, setRazonnoestudio] = useState([]);
    const [razonnosalud, setRazonnosalud] = useState([]);
    const [salud, setSalud] = useState([]);
    const [parentescos, setParentescos] = useState([]);
    const [tiposcreacioncabeza, setTiposcreacioncabeza] = useState([]);
    const [tiposauto, setTiposauto] = useState([]);
    const [estadoscivil, setEstadoscivil] = useState([]);
    const [ingresosEconomicos, setIngresosEconomicos] = useState([]);
    const [condicionesMigratorias, setCondicionesMigratorias] = useState([]);
    const [Cargando, setCargando] = useState(false);
    const [perFechacreacion, setPerFechacreacion] = useState();
    const [perFechamodificacion, setPerFechamodificacion] = useState();
    const [preloadPersona, setPreloadPersona] = useState(null);
    const {register, handleSubmit, control, setValue, reset, watch, formState: { errors }} = useForm();
    const perSexo = watch('perSexo');
    const perGestante = watch('perGestante');
    const perLactante = watch('perLactante');
    const perEdad = watch('perEdad');
    const cabTipo = watch('cabTipo');
    const perTipodiscapacidad = watch('perTipodiscapacidad');
    const perSalud = watch('perSalud');
    const perPaisorigen = watch('perPaisorigen');
    const perFallecido = watch('perFallecido');
    const perAsisteescuela = watch('perAsisteescuela');
    const perLgtbi = watch('perLgtbi');
    useEffect(() => {
        if (pendingPaisOrigen && paises.length > 0) {
            setValue('perPaisorigen', pendingPaisOrigen);
            setPendingPaisOrigen(null);
        }
    }, [pendingPaisOrigen, paises, setValue]);
    useEffect(() => {
        if(tiposEstrato.length >0 
            && tiposOrientacionSexual.length >0 
            && tiposIdentidadGenero.length >0 
            && preloadPersona){
            reset(preloadPersona);
            setPreloadPersona(null);
        }
    }, [preloadPersona, reset]);
    
    useEffect(() => {
        if (!hasRun.current) {
            const fetchData = async () => {
                const url = '/caracterizacion/crearformulariopersona';
                const obj = {id: id, idCabezaFamilia: idCabezaFamilia}
                try {
                    setCargando(true);
                    const response = await apiService.post(url, obj, token);
                    const result = await response.data;
                    
                    setEstadosvictima(result.estadosvictima);
                    setTiposcreacioncabeza(result.tiposcreacioncabeza);                    
                    setPaises(result.paises);
                    setTipoIdentificaciones(result.tipoidentificacion);
                    setSexo(result.sexo);
                    setMinoria(result.minoria);
                    setDiscapacidades(result.discapacidades);
                    setCausasdiscapacidad(result.causasdiscapacidad);
                    setOficios(result.oficios);
                    setActividades(result.actividades);
                    setTipoestudios(result.tipoestudios);
                    setRazonnoestudio(result.razonnoestudio);
                    setRazonnosalud(result.razonnosalud);
                    setParentescos(result.parentescos);
                    setSalud(result.salud);
                    setTiposauto(result.tiposauto);
                    setEstadoscivil(result.estadoscivil);
                    setTiposOrientacionSexual(result.orientacionessexuales);
                    setTiposIdentidadGenero(result.identidadesgenero);
                    setTiposHabitanteCalle(result.tiposHabitanteCalle);
                    setTiposEstrato(result.estratosSocioeconomico);
                    setIngresosEconomicos(result.ingresosFamiliares);
                    setCondicionesMigratorias(result.condicionesMigratorias);
                    if(result.persona){
                        const edad = moment(result.persona.perFechanac, 'YYYY-MM-DD', true).isValid() 
                            ? moment.utc(result.persona.perFechanac).set({ hour: 12, minute: 0, second: 0 }).format('YYYY-MM-DDTHH:mm:ss')
                            : moment().set({ hour: 12, minute: 0, second: 0 }).toISOString();
                        result.persona.perFechanac = edad;
                        CalcularCicloVida(edad);
                        result.persona.perFecharegistrosipod = moment(result.persona.perFecharegistrosipod, 'YYYY-MM-DD', true).isValid()
                            ? moment.utc(result.persona.perFecharegistrosipod.substr(0, 10)).set({ hour: 12, minute: 0, second: 0 }).format('YYYY-MM-DDTHH:mm:ss')
                            : moment().set({ hour: 12, minute: 0, second: 0 }).toISOString();
                        setPerFechacreacion(result.persona.perFechacreacion);
                        setPerFechamodificacion(result.persona.perFechamodificacion);
                        result.persona.usrId = user
                        result.persona.cabIdcabezafamilia = idCabezaFamilia
                        result.persona.perIdpersona = idPersona
                        result.persona.cabNodeclaracion = result.cabezafamilia.cabNodeclaracion
                        result.persona.cabTipo = result.cabezafamilia.cabTipo
                        result.persona.cabTipoautoid = result.cabezafamilia.cabTipoautoid
                        result.persona.gruIdparentesco = (idPersona === idCabezaFamilia)?'1':result.personagrupofamiliar.gruIdparentesco
                        setPreloadPersona(result.persona);
                        if (result.persona.perTipoid === '14') { // Cedula de Ciudadania
                            setPendingPaisOrigen('52'); // Colombia
                        }
                        setValue('perIdentidadgenero', EstablecerIdentidadGenero(perLgtbi, perSexo));
                        setValue('perOrientacionsexual', perLgtbi ? watch('perOrientacionsexual') : '4');
                        setValue('strNombreidentitario', perLgtbi ? watch('strNombreidentitario') : '');
                    } else {
                        const persona = {};
                        persona.usrId = user
                        persona.cabIdcabezafamilia = idCabezaFamilia ?? idPersona
                        persona.perIdpersona = idPersona
                        if(programa === '3'){
                            persona.cabNodeclaracion = idCabezaFamilia
                            persona.perFecharegistrosipod = moment().set({ hour: 12, minute: 0, second: 0 }).toISOString();
                            persona.cabTipo = '2'
                            handleCabTipoChange('2', result.estadosvictima);
                            persona.perIncluido = '4'
                        } else {
                            persona.cabNodeclaracion = result.cabezafamilia?.cabNodeclaracion || ''
                            persona.perFecharegistrosipod = moment(result.cabezafamilia?.cabFechaestadoruv, 'YYYY-MM-DD', true).isValid()
                                ? moment.utc(result.cabezafamilia.cabFechaestadoruv.substr(0, 10)).set({ hour: 12, minute: 0, second: 0 }).format('YYYY-MM-DDTHH:mm:ss')
                                : moment().set({ hour: 12, minute: 0, second: 0 }).toISOString();
                            persona.cabTipo = result.cabezafamilia?.cabTipo || ''
                            persona.perIncluido = result.cabezafamilia?.cabEstadoruv || ''
                        }
                        persona.cabTipoautoid = ''
                        persona.gruIdparentesco = '1'
                        persona.perLgtbi = false
                        setPreloadPersona(persona);
                    }
                    if(result.cabezafamilia){
                        handleCabTipoChange(result.cabezafamilia.cabTipo, result.estadosvictima);
                    }
                } catch (error) {
                    Mensaje('Error', 'Error al cargar los datos');
                    console.error('Error fetching data:', error);
                } finally {
                  setCargando(false);
                }
                
                
            };
    
            fetchData();
            hasRun.current = true;
        }
    }, [id, idPersona, token, setValue, user, reset, idCabezaFamilia, navigate]);
    function EstablecerIdentidadGenero(lgbti , sexo){
        if (!lgbti) {
            return sexo == 'MUJER' ? '4' : sexo == 'HOMBRE' ? '2' : '';
        }
        
        return watch('perIdentidadgenero') || '';
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        data.perFechanac = moment(data.perFechanac).format('YYYY-MM-DD');
        data.perFecharegistrosipod = moment(data.perFecharegistrosipod).format('YYYY-MM-DD');
        
        if(id==="0"){
            if(idCabezaFamilia === "0"){
                data.cabIdcabezafamilia = data.perIdpersona;
                if(programa === '3'){
                    data.cabNodeclaracion = data.cabIdcabezafamilia
                    data.perFecharegistrosipod = moment().set({ hour: 12, minute: 0, second: 0 }).toISOString();
                    data.cabTipo = '2'
                    data.perIncluido = '4'
                }
            }
            url = '/caracterizacion/crearnuevapersona';
        }else{
            url = '/caracterizacion/actualizarpersona';
        }
        await apiService.post(url, data, token)
        .then((response) => {
            if(response.status === 200){
                Mensaje('Guardar persona', 'Persona guardada exitosamente');
                void navigate(`/caracterizacion/grupofamiliar/${data.cabIdcabezafamilia}`);
            } else {
                Mensaje('Guardar persona', 'Error al guardar persona');
            }
        }).catch((error) => {
            if(error.status === 422){
                const respuestalista = error.response.data.errors.map(error => `<li>${error.field}-${error.message}</li>`).join('');
                Mensaje('Guardar persona fallo', `<ul>${respuestalista}</ul>`);
            } else if(error.status === 404){
                Mensaje('Guardar persona fallo', 'Persona no encontrada');
            } else if(error.status === 409){
                Mensaje('Guardar persona fallo', error.response.data);
            }else {
                Mensaje('Guardar persona fallo', `Error al guardar persona ${error}`);
            }
        })
        .finally(() => {
            setCargando(false);
        });
      };

    function CalcularEdad(date){
        setValue('perEdad', moment().diff(date, 'years'));
        CalcularCicloVida(moment().diff(date, 'years'));
    }

    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            html: text,
        });
    };
    function handleCabTipoChange(selectedValue, estadosVictima) {
        reset((prevValues) => ({
            ...prevValues,
            cabTipo: selectedValue,
        }));
        if(selectedValue === '1'){
            const filteredEstadosIncluido = estadosVictima.filter(
                (estado) => estado.id === '1'
            );
            setEstadosvictimaFiltrados(filteredEstadosIncluido);
        }else{
            const filteredEstadosNoAparece = estadosVictima.filter(
                (estado) => estado.id !== '1'
            );
            setEstadosvictimaFiltrados(filteredEstadosNoAparece);
        }
    }
    const handleUppercase = (event) => {
        const uppercasedValue = event.target.value.replaceAll(/[^\p{L}0-9 ]/gu, '').toUpperCase();
        const fieldname = event.target.name;
        setValue(fieldname, uppercasedValue);
    };
    function ActivarCondicionMigratoria(paisOrigen) {
        if (paisOrigen && paisOrigen !== '52') { // Si el país de origen no es Colombia
            setValue('intCondicionmigratoriaid', ''); // Limpiar el valor de condición migratoria    
        }
    }
    function CalcularCicloVida(edad) {
        if (edad < 0) {
            setValue('perCiclovida', ''); // Edad negativa, valor vacío
        } else if (edad <= 6) {
            setValue('perCiclovida', 'PRIMERA INFANCIA (0-6 AÑOS)');
        } else if (edad <= 11) {
            setValue('perCiclovida', 'INFANCIA (7-11 AÑOS)');
        } else if (edad <= 17) {
            setValue('perCiclovida', 'ADOLESCENCIA (12-17 AÑOS)');
        } else if (edad <= 28) {
            setValue('perCiclovida', 'JUVENTUD(18-28 AÑOS)');
        } else if (edad <= 54 ){
            setValue('perCiclovida', 'ADULTEZ (29-54 AÑOS)');
        } else {
            setValue('perCiclovida', 'ADULTO MAYOR (MAYOR DE 55 AÑOS)');
        }
    }
    return(
        <div className="content-wrapper">
            <SeccionPageHeader 
                title="Formulario persona"
                idCabezaFamilia={idCabezaFamilia}
                url={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`}
                nombreurl="Grupo familiar"
                nombreform="persona"
                />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    {(idCabezaFamilia !== "0") && 
                        <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia}/>
                    }
                    <div className="row">
                    {/* left column */}
                    <div className="col-md-12">
                        <div className="card card-info">
                        <div className="card-header">
                            <h3 className="card-title">Persona</h3>
                        </div>
                        {/* /.card-header */}
                        {/* form start */}
                        <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <div className="card-body">
                                <div className="card">
                                    <div className="card-header">
                                    <h5 className="card-title m-0">Identificaci&oacute;n - Datos Personales {idCabezaFamilia === "0" && '- Jefe de Hogar'}</h5>
                                    </div>
                                    <div className="card-body">
                                    <div className="row">
                                        <div className='col-md-4'>
                                            <div className='row'>
                                                <div className="col-md-12">
                                                    Fecha de creaci&oacute;n: <b>{perFechacreacion}</b><input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                Fecha &uacute;ltima caracterizaci&oacute;n: <b>{perFechamodificacion}</b>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-8' hidden={programa === "3"}>
                                            <div className="row">
                                                <div className='col-md-12'>
                                                    <label htmlFor="cabTipo">Seleccione la caracter&iacute;stica del hogar.</label>
                                                    <select 
                                                        id="cabTipo" 
                                                        {...register('cabTipo')} 
                                                        className='form-control' 
                                                        onChange={(e) => {
                                                            handleCabTipoChange(e.target.value, estadosvictima);
                                                        }}>
                                                        <option value="">Seleccionar</option>
                                                        {tiposcreacioncabeza.map((option) => (
                                                        <option key={option.id} value={option.id}>
                                                            {option.tipTipo}
                                                        </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {cabTipo !== '' && <div className='row'>
                                        <div className="col-md-4" hidden={programa === "3"}>
                                            <div className="form-group" >
                                                <label htmlFor="perIncluido">Estado victima</label>
                                                <select id="perIncluido" {...register('perIncluido', { required: true })} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {estadosvictimaFiltrados.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.estEstado}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perIncluidoclassName && <p style={{color: 'red'}}>Seleccione estado</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-4" hidden={programa === "3"}>
                                            <div className="form-group" >
                                                <label htmlFor="cabNodeclaracion">Codigo FUD</label>
                                                <input id="cabNodeclaracion" {...register('cabNodeclaracion', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Codigo fud"
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace(/[^A-Za-z0-9]/g, ''); // Remove non-alphanumeric characters
                                                        setValue('cabNodeclaracion', value.toUpperCase()); // Update the value in the form
                                                      }}/>
                                                {errors.cabNodeclaracion && <p style={{color: 'red'}}>Digite codigo FUD</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-2" hidden={programa === "3"}>
                                            <div className="form-group">
                                                <label htmlFor="perFecharegistrosipod">Fecha declaraci&oacute;n victimas</label>
                                                <Controller
                                                    control={control}
                                                    name="perFecharegistrosipod"
                                                    rules={{ required: "Seleccione fecha declaraci&oacute;n victimas" }}
                                                    render={({ field }) => (
                                                        <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                            <DatePicker
                                                            placeholderText="fecha"
                                                            onChange={(date) => field.onChange(date)}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={field.value ? new Date(`${field.value}`) : null}
                                                            customInput={<CustomInput />}
                                                            locale="es"
                                                            dateFormat="yyyy-MM-dd"
                                                            maxDate={new Date()}
                                                            />
                                                        </div>
                                                    )}
                                                />
                                                {errors.perFecharegistrosipod && <p style={{color: 'red'}}>Digite fecha declaraci&oacute;n victima</p>}
                                            </div>
                                        </div>
                                    </div>}
                                    <br/>
                                    {cabTipo !== '' && <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perTipoid">Tipo identificaci&oacute;n</label>
                                                <select id="perTipoid" className='form-control' 
                                                    {...register('perTipoid', { required: true })}
                                                    onChange={(e) => {
                                                        if (e.target.value === '14') { // Cedula de Ciudadania
                                                            setPendingPaisOrigen('52'); // Colombia
                                                        }
                                                    }}>
                                                    <option value="">Seleccionar</option>
                                                    {tipoIdentificaciones.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.tipTipoidentificacion}-{option.tipDescripcion}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perTipoid && <p style={{color: 'red'}}>Seleccionar tipo identificaci&oacute;n</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perIdpersona">Identificaci&oacute;n</label>
                                                <input id="perIdpersona" className="form-control" 
                                                    {...register('perIdpersona', { required: true })}
                                                    placeholder="Identificacion"
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace(/[^A-Za-z0-9]/g, ''); // Remove non-alphanumeric characters
                                                        setValue('perIdpersona', value); // Update the value in the form
                                                      }}/>
                                                {errors.perIdpersona && <p style={{color: 'red'}}>Digite el documento</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perPaisorigen">Pais origen</label>
                                                <select 
                                                    id="perPaisorigen" 
                                                    className='form-control' 
                                                    onClick={(e) => {
                                                        ActivarCondicionMigratoria(e.target.value);
                                                        setValue('perPaisorigen', e.target.value);
                                                    }}
                                                    {...register('perPaisorigen', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {paises.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.iso} - {option.pais}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perPaisorigen && <p style={{color: 'red'}}>Seleccione pais origen</p>}
                                            </div>
                                        </div>
                                    </div>}
                                    {cabTipo !== '' && <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perNombre1">Primer nombre</label>
                                                <input id="perNombre1" className="form-control" 
                                                    {...register('perNombre1', { required: true })}
                                                    onChange={handleUppercase}
                                                    placeholder="Primer Nombre"/>
                                                {errors.perNombre1 && <p style={{color: 'red'}}>Digite primer nombre</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perNombre2">Segundo nombre</label>
                                                <input id="perNombre2" className="form-control" 
                                                    {...register('perNombre2')}
                                                    onChange={handleUppercase}
                                                    placeholder="Segundo nombre"/>
                                                {errors.perNombre2 && <p style={{color: 'red'}}>Digite segundo nombre</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perApellido1">Primer apellido</label>
                                                <input id="perApellido1" className="form-control" 
                                                    {...register('perApellido1', { required: true })}
                                                    onChange={handleUppercase}
                                                    placeholder="Primer apellido"/>
                                                {errors.perApellido1 && <p style={{color: 'red'}}>Digite primer apellido</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perApellido2">Segundo apellido</label>
                                                <input id="perApellido2" className="form-control" 
                                                    {...register('perApellido2')}
                                                    onChange={handleUppercase}
                                                    placeholder="Segundo apellido"/>
                                                {errors.perApellido2 && <p style={{color: 'red'}}>Digite segundo apellido</p>}
                                            </div>
                                        </div>
                                    </div>}
                                    {cabTipo !== '' && <div className='row'>
                                        <div className='col-md-4'>
                                            <div className="form-group" >
                                                <label htmlFor="gruIdparentesco">Parentesco</label>
                                                <select id="gruIdparentesco" {...register('gruIdparentesco', { required: true })} className='form-control' >
                                                    {idPersona !== idCabezaFamilia && <option value="">Seleccionar</option>}
                                                    {parentescos.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.parParentesco}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.gruIdparentesco && <p style={{color: 'red'}}>Seleccione parentesco</p>}
                                            </div>
                                        </div>
                                        <div className='col-md-4'>
                                            <div className="form-group" >
                                                <label htmlFor="perEstadocivil">Estado civil</label>
                                                <select id="perEstadocivil" {...register('perEstadocivil')} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {estadoscivil.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.estEstadocivil}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perIncluidoclassName && <p style={{color: 'red'}}>Seleccione estado</p>}
                                            </div>
                                        </div>
                                    </div>}
                                    {cabTipo !== '' && <div className="row">
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label htmlFor="perFechanac">Fecha Nacimiento</label>
                                                <Controller
                                                    control={control}
                                                    name="perFechanac"
                                                    rules={{ required: "Seleccione fecha nacimiento" }}
                                                    render={({ field }) => (
                                                        <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                            <DatePicker
                                                            placeholderText="fecha"
                                                            onChange={(date) => {field.onChange(date); CalcularEdad(date);}}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={field.value ? new Date(`${field.value}`) : null}
                                                            customInput={<CustomInput />}
                                                            locale="es"
                                                            dateFormat="yyyy-MM-dd"
                                                            maxDate={new Date()}
                                                            />
                                                        </div>
                                                    )}
                                                />
                                                {errors.perFechanac && <p style={{color: 'red'}}>Seleccione fecha nacimiento</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group" >
                                                <label htmlFor="perEdad">Edad</label>
                                                <input id="perEdad" className="form-control" 
                                                    {...register('perEdad', { required: true })}
                                                    placeholder="Edad"/>
                                                {errors.perEdad && <p style={{color: 'red'}}>Digite edad</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group" >
                                                <label htmlFor="perCiclovida">Ciclo de vida</label>
                                                <input
                                                    disabled={true}
                                                    id="perCiclovida" 
                                                    className="form-control" 
                                                    {...register('perCiclovida')}
                                                    placeholder="Ciclo de vida"/>
                                                {errors.perCiclovida && <p style={{color: 'red'}}>Digite edad</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perSexo">Sexo</label>
                                                <select 
                                                    id="perSexo" 
                                                    className='form-control' 
                                                    {...register('perSexo', { required: true, 
                                                        onChange: (e) => {
                                                            setValue('perSexo', e.target.value);
                                                            setValue('strNombreidentitario', e.target.checked ? watch('strNombreidentitario') : '');
                                                            setValue('perOrientacionsexual', e.target.checked ? watch('perOrientacionsexual') : '4');
                                                            setValue('perIdentidadgenero', EstablecerIdentidadGenero(e.target.checked, watch('perSexo')));
                                                        }
                                                     })}>
                                                    <option value="">Seleccionar</option>
                                                    {sexo.map((option) => (
                                                    <option key={option.sexNombre} value={option.sexNombre}>
                                                        {option.sexNombre}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perSexo && <p style={{color: 'red'}}>Seleccione sexo</p>}
                                            </div>
                                        </div>
                                        {(perSexo === 'MUJER') &&
                                            <div className="col-md-3">
                                                <div className="form-group" >
                                                    <label htmlFor="perMbuscadora">Mujer buscadora</label>
                                                    <select 
                                                        id="perMbuscadora" 
                                                        {...register('perMbuscadora')}  
                                                        className='form-control'
                                                        disabled={perSexo !== 'MUJER'}>
                                                        <option value="">Seleccionar</option>
                                                        <option value="SI">SI</option>
                                                        <option value="NO">NO</option>
                                                    </select>
                                                    {errors.perMbuscadora && <p style={{color: 'red'}}>Seleccione pregunta buscadora</p>}
                                                </div>
                                            </div>
                                        }
                                        
                                    </div>}
                                    {cabTipo !== '' && <div className="row">
                                        <div className="col-md-2" style={{position: 'relative', alignItems: 'center'}}>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('perFallecido')}
                                                    className="custom-control-input" id="SwitchFallecido"/>
                                                <label className="custom-control-label" htmlFor="SwitchFallecido">Fallecido</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                            {cabTipo !== '' && !perFallecido && <div className="card">
                                <div className="card-header">
                                <h5 className="card-title m-0">Caracter&iacute;sticas Diferenciales</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6" style={{position: 'relative', alignItems: 'center'}}>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('perLgtbi', { onChange: (e) => {
                                                        setValue('perLgtbi', e.target.checked)
                                                        setValue('strNombreidentitario', e.target.checked ? watch('strNombreidentitario') : '');
                                                        setValue('perOrientacionsexual', e.target.checked ? watch('perOrientacionsexual') : '4');
                                                        setValue('perIdentidadgenero', EstablecerIdentidadGenero(e.target.checked, watch('perSexo')));
                                                    } })}
                                                    className="custom-control-input" id="SwitchLgtbi"/>
                                                <label className="custom-control-label" htmlFor="SwitchLgtbi">OSIEG (Orientaciones Sexuales, Identidades y Expresiones de G&eacute;nero Diversas)</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {perLgtbi && <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="strNombreidentitario">Nombre identitario</label>
                                                <input id="strNombreidentitario" className="form-control" 
                                                    {...register('strNombreidentitario')}
                                                    onChange={handleUppercase}
                                                    placeholder="Nombre identitario"/>
                                                {errors.strNombreidentitario && <p style={{color: 'red'}}>Digite nombre identitario</p>}
                                            </div>
                                        </div>}
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perOrientacionsexual">Orientaci&oacute;n sexual</label>
                                                <select 
                                                    id="perOrientacionsexual" 
                                                    className='form-control' 
                                                    disabled={!perLgtbi}
                                                    {...register('perOrientacionsexual', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {tiposOrientacionSexual.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.oriOrientacionsexual}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perOrientacionsexual && <p style={{color: 'red'}}>Seleccione orientacion sexual</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perIdentidadgenero">Identidad genero</label>
                                                <select 
                                                    id="perIdentidadgenero" 
                                                    className='form-control' 
                                                    disabled={!perLgtbi}
                                                    {...register('perIdentidadgenero', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {tiposIdentidadGenero.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.ideIdentidad}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perIdentidadgenero && <p style={{color: 'red'}}>Seleccione identidad genero</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perHabitantecalle">Habitanza calle</label>
                                                <select id="perHabitantecalle" className='form-control' {...register('perHabitantecalle', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {tiposHabitanteCalle.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.habTipohabitantecalle}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perHabitantecalle && <p style={{color: 'red'}}>Seleccione habitanza calle</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perCampesino">Campesino</label>
                                                <select id="perCampesino" {...register('perCampesino', { required: true })} className='form-control'>
                                                    <option value="">Seleccionar</option>
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.perCampesino && <p style={{color: 'red'}}>Seleccione dato</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor="perTipominoria">Etn&iacute;as</label>
                                                <select id="perTipominoria" className='form-control' {...register('perTipominoria', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {minoria.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.minMinoria}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perTipominoria && <p style={{color: 'red'}}>Seleccione minoria</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perEstrato">Estrato socioeconomico</label>
                                                <select id="perEstrato" className='form-control' {...register('perEstrato', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {tiposEstrato.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.tipEstrato}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perEstrato && <p style={{color: 'red'}}>Seleccione estrato</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-5">
                                            <div className="form-group" >
                                                <label htmlFor="perTipodiscapacidad">Discapacidad</label>
                                                <select id="perTipodiscapacidad" {...register('perTipodiscapacidad')} className='form-control' >
                                                    {discapacidades.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.disDiscapacidad}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perTipodiscapacidad && <p style={{color: 'red'}}>Seleccione discapacidad</p>}
                                            </div>
                                        </div>
                                        {perTipodiscapacidad !== '0' && <div className="col-md-6">
                                            <div className="form-group" >
                                                <label htmlFor="perCausadiscapacidadid">Causa discapacidad</label>
                                                <select id="perCausadiscapacidadid" {...register('perCausadiscapacidadid', { validate: value => {
                                                                if (perTipodiscapacidad !== '0' && !value) {
                                                                return 'Seleccione pregunta causa discapacidad';
                                                                }
                                                                return true;
                                                            }
                                                            })} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {causasdiscapacidad.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.disCausa}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perCausadiscapacidadid && <p style={{color: 'red'}}>Seleccione causa discapacidad</p>}
                                            </div>
                                        </div>}
                                    </div>
                                    {programa !== '3' && (<div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group" >
                                                <label htmlFor="cabTipoautoid">Tipo auto</label>
                                                <select id="cabTipoautoid" {...register('cabTipoautoid')} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {tiposauto.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.tipTipoauto}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.tiposauto && <p style={{color: 'red'}}>Seleccione tipo auto</p>}
                                            </div>
                                        </div>
                                    </div>)}
                                    <div className="row">
                                    {(perSexo === 'MUJER') && (perEdad >= 8 && perEdad <= 49) && <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group" >
                                                        <label htmlFor="perGestante">Gestante</label>
                                                        <select 
                                                            id="perGestante" 
                                                            {...register('perGestante', { validate: value => {
                                                                if (perSexo === 'MUJER' && !value) {
                                                                return 'Seleccione pregunta gestación';
                                                                }
                                                                return true;
                                                            }
                                                            })}  
                                                            className='form-control'
                                                            disabled={perSexo === 'HOMBRE'}>
                                                            <option value="">Seleccionar</option>
                                                            <option value="SI">SI</option>
                                                            <option value="NO">NO</option>
                                                        </select>
                                                        {errors.perGestante && <p style={{color: 'red'}}>Seleccione pregunta gestancia</p>}
                                                    </div>
                                                </div>
                                            </div>
                                            {watch('perGestante') === 'SI' && <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group" >
                                                        <label htmlFor='perMesesgestacion'>Meses</label>
                                                        <select id='perMesesgestacion' {...register('perMesesgestacion', { validate: value => {
                                                                if (perGestante === 'SI' && !value) {
                                                                return 'Seleccione meses';
                                                                }
                                                                return true;
                                                            }
                                                            })} className='form-control' disabled={perSexo === 'HOMBRE'}>
                                                            <option value="">Seleccionar</option>
                                                            <option value="1">1</option>
                                                            <option value="2">2</option>
                                                            <option value="3">3</option>
                                                            <option value="4">4</option>
                                                            <option value="5">5</option>
                                                            <option value="6">6</option>
                                                            <option value="7">7</option>
                                                            <option value="8">8</option>
                                                            <option value="9">9</option>
                                                        </select>
                                                        {errors.perMesesgestacion && <p style={{color: 'red'}}>Seleccione meses gestaci&oacute;n</p>}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="perFechagestancia">Fecha Gestancia</label>
                                                        <Controller
                                                            control={control}
                                                            name="perFechagestancia"
                                                            rules={{
                                                                validate: {
                                                                esMUJER: (value) => {
                                                                    if (perGestante === 'SI' && !value) {
                                                                        return 'Seleccione fecha';
                                                                    }
                                                                        return true;
                                                                    }
                                                                }
                                                            }}
                                                            render={({ field }) => (
                                                                <DatePicker
                                                                placeholderText="fecha"
                                                                onChange={(date) => field.onChange(date)}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value}
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                disabled={perSexo === 'HOMBRE'}
                                                                maxDate={new Date()}
                                                                />
                                                            )}
                                                        />  
                                                        {errors.perFechagestancia && <p style={{color: 'red'}}>Seleccione fecha gestaci&oacute;n</p>}
                                                        
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>}
                                        {(perSexo === 'MUJER') && (perEdad >= 8 && perEdad <= 49) && <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group" >
                                                        <label htmlFor="perLactante">Lactante</label>
                                                        <select id="perLactante" {...register('perLactante', { validate: value => {
                                                                if (perSexo === 'MUJER' && !value) {
                                                                return 'Seleccione pregunta lactancia';
                                                                }
                                                                return true;
                                                            }
                                                            })} className='form-control' disabled={perSexo === 'HOMBRE'}>
                                                            <option value="">Seleccionar</option>
                                                            <option value="SI">SI</option>
                                                            <option value="NO">NO</option>
                                                        </select>
                                                        {errors.perLactante && <p style={{color: 'red'}}>Seleccione pregunta lactancia</p>}
                                                    </div>
                                                </div>
                                            </div>
                                            {watch('perLactante') === 'SI' && <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="perFechalactancia">Fecha Lactancia</label>
                                                        <Controller
                                                            control={control}
                                                            name="perFechalactancia"
                                                            rules={{
                                                                validate: {
                                                                esMUJER: (value) => {
                                                                    if (perLactante === 'SI' && !value) {
                                                                        return 'Seleccione fecha';
                                                                    }
                                                                        return true;
                                                                    }
                                                                }
                                                            }}
                                                            render={({ field }) => (
                                                                <DatePicker
                                                                placeholderText="fecha"
                                                                onChange={(date) => field.onChange(date)}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value}
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                disabled={perSexo === 'HOMBRE'}
                                                                maxDate={new Date()}
                                                                />
                                                            )}
                                                        />  
                                                        {errors.perFechalactancia && <p style={{color: 'red'}}>Seleccione fecha lactancia</p>}
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>}
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className  ="form-group" >
                                                <label htmlFor="perMsacudiente">Menor sin Acudiente</label>
                                                <select id="perMsacudiente" {...register('perMsacudiente', { validate: value => {
                                                            if (perEdad < 18 && !value) {
                                                            return 'Seleccione pregunta menor sin acudiente';
                                                            }
                                                            return true;
                                                        }
                                                        })} className='form-control' disabled={perEdad >= 18}>
                                                    <option value="">Seleccionar</option>
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.perMsacudiente && <p style={{color: 'red'}}>Seleccione pregunta menor sin acudiente</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className  ="form-group" >
                                                <label htmlFor="intIngresoeconomico">Ingresos economicos</label>
                                                <select id="intIngresoeconomico" {...register('intIngresoeconomico', { validate: value => {
                                                            if (perEdad > 18 && !value) {
                                                            return 'Seleccione pregunta ingresos economicos';
                                                            }
                                                            return true;
                                                        }
                                                        })} className='form-control' disabled={perEdad <= 18}>
                                                    <option value="">Seleccionar</option>
                                                    {ingresosEconomicos.map((option) => (
                                                        <option key={option.id} value={option.id}>
                                                            {option.str_nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.intIngresoeconomico && <p style={{color: 'red'}}>Seleccione pregunta ingresos economicos</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div hidden={perSexo === 'HOMBRE'} className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="bolMadrecabeza">Madre Cabeza de Familia</label>
                                                <select id="bolMadrecabeza" {...register('bolMadrecabeza')} className='form-control'>
                                                    <option value="">Seleccionar</option>
                                                    <option value="true">SI</option>
                                                    <option value="false">NO</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="bolPobrezaextrema">Pobreza Extrema</label>
                                                <select id="bolPobrezaextrema" {...register('bolPobrezaextrema')} className='form-control'>
                                                    <option value="">Seleccionar</option>
                                                    <option value="true">SI</option>
                                                    <option value="false">NO</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="bolVictimaconflicto">Víctima del Conflicto</label>
                                                <select id="bolVictimaconflicto" {...register('bolVictimaconflicto')} className='form-control'>
                                                    <option value="">Seleccionar</option>
                                                    <option value="true">SI</option>
                                                    <option value="false">NO</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="bolAfiliadoserviciofunerario">Atendido por las exequ&iacute;as del jardin cementerio universal</label>
                                                <select id="bolAfiliadoserviciofunerario" {...register('bolAfiliadoserviciofunerario')} className='form-control'>
                                                    <option value="">Seleccionar</option>
                                                    <option value="true">SI</option>
                                                    <option value="false">NO</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div hidden={perPaisorigen === '52'} className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="intCondicionmigratoriaid">Condición Migratoria</label>
                                                <select 
                                                    id="intCondicionmigratoriaid" 
                                                    {...register('intCondicionmigratoriaid')} 
                                                    className='form-control'>
                                                    <option value="">Seleccionar</option>
                                                    {condicionesMigratorias.map((option) => (
                                                        <option key={option.id} value={option.id}>
                                                            {option.strNombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {(cabTipo === '1' || programa === '3') && !perFallecido && <div className="card">
                                <div className="card-header">
                                <h5 className="card-title m-0">Capacidades y Potencialidades de la PD</h5>
                                </div>
                                <div className="card-body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="perOficioactual">Ocupaci&oacute;n</label>
                                            <select id="perOficioactual" {...register('perOficioactual')} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {oficios.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.ofiOficio}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.perOficioactual && <p style={{color: 'red'}}>Seleccione oficio actual</p>}
                                        </div>
                                    </div>
                                    {programa === '3' && <div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="perActactual">Actividad Actual</label>
                                            <select id="perActactual" {...register('perActactual')} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {actividades.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.actActividad}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.perActactual && <p style={{color: 'red'}}>Seleccione actividad actual</p>}
                                        </div>
                                    </div>}
                                </div>
                                </div>
                            </div>}
                            {(cabTipo === '1' || programa === '3') && !perFallecido && <div className="card">
                                <div className="card-header">
                                <h5 className="card-title m-0">Educaci&oacute;n y Salud</h5>
                                </div>
                                <div className="card-body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="perAsistiaescuela">Asistia a escuela</label>
                                            <select id="perAsistiaescuela" {...register('perAsistiaescuela', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.perAsistiaescuela && <p style={{color: 'red'}}>Seleccione pregunta asiste escuela</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="perTipoestudio">Nivel Estudio</label>
                                            <select id="perTipoestudio" {...register('perTipoestudio', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {tipoestudios.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.tipDescripcion}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.perTipoestudio && <p style={{color: 'red'}}>Seleccione tipo estudio</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="perUltimogrado">&uacute;ltimo grado</label>
                                            <select id="perUltimogrado" {...register('perUltimogrado')} className="form-control">
                                                <option value="">Sin Dato</option>
                                                {Array.from({ length: 12 }, (_, i) => i + 0).map((grade) => (
                                                    <option key={grade} value={grade}>
                                                        {grade}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.perUltimogrado && <p style={{ color: 'red' }}>Seleccione el &uacute;ltimo grado</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="perAsisteescuela">Asiste Escuela</label>
                                            <select id="perAsisteescuela" 
                                                {...register('perAsisteescuela', 
                                                    { 
                                                        required: true,
                                                        onChange: (e) => {
                                                            if (e.target.value != 'NO') {
                                                                
                                                                setValue('perRazonnoestudio', '');
                                                            }
                                                        } 
                                                    },
                                                )} 
                                                className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.perAsisteescuela && <p style={{color: 'red'}}>Seleccione asiste escuela</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="perTipoestudioactual">Estudio Actual</label>
                                            <select {...register('perTipoestudioactual', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {tipoestudios.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.tipDescripcion}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.perTipoestudioactual && <p style={{color: 'red'}}>Seleccione tipo estudio actual</p>}
                                        </div>
                                    </div>
                                    {perAsisteescuela === 'NO' && (<div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="perRazonnoestudio">Raz&oacute;n No estudia</label>
                                            <select id="perRazonnoestudio" {...register('perRazonnoestudio', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {razonnoestudio.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.razRazonnoestudio}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.perRazonnoestudio && <p style={{color: 'red'}}>Seleccione razon no estudio</p>}
                                        </div>
                                    </div>
                                    )}
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="perSalud">R&eacute;gimen de Salud</label>
                                            <select id="perSalud" {...register('perSalud', { required: true })} className='form-control' >
                                                 <option value="">Seleccionar</option>
                                                {salud.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.salDescripcion}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.perSalud && <p style={{color: 'red'}}>Seleccione salud</p>}
                                        </div>
                                    </div>
                                    {(perSalud == 5 || perSalud == 4) && <div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="perRazonnosalud">Raz&oacute;n No Salud</label>
                                            <select id="perRazonnosalud" {...register('perRazonnosalud', { validate: value => {
                                                        if (perSalud > 2 && !value) {
                                                        return 'Seleccione razon no salud';
                                                        }
                                                        return true;
                                                    }
                                                    })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {razonnosalud.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.razRazonnosalud}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.perRazonnosalud && <p style={{color: 'red'}}>Seleccione razon no salud</p>}
                                        </div>
                                    </div>}
                                    <div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="perSisben">Sisben</label>
                                            <select id="perSisben" {...register('perSisben')} className='form-control' >
                                                <option value="">SIN DATO</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.perSisben && <p style={{color: 'red'}}>Seleccione sisben</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="perLeeescribe">Lee/Escribe</label>
                                            <select id="perLeeescribe" {...register('perLeeescribe', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.perLeeescribe && <p style={{color: 'red'}}>Seleccione pregunta lee/escribe</p>}
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>}

                            </div>
                            {/* /.card-body */}
                            <div className="card-footer">
                                 <div style={{ display: 'flex', gap: '12px' }}>
                                    {Cargando && <button type="submit" className="btn btn-info" disabled>Guardar</button>}
                                    {!Cargando && <button type="submit" className="btn btn-info">Guardar</button>}
                                    <button type="button" className="btn btn-info" onClick={() => navigate(-1)}>Cancelar</button>
                                </div>
                            </div>
                            {/* /.card-footer */}
                        </form>
                        </div>
                        {/* /.card */}

                    </div>
                    {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
        </div>
    )


}